import { Fragment, ReactElement } from 'react';

import { TableCell, Typography } from '@mui/material';

import { formatDateForLocale } from '@/utils';

import { RecentActivity } from '../types';
import { StyledTableRow } from './Filters.components';

export const RecentActivityTableRow = (props: RecentActivity): ReactElement => {
  const formattedDate = formatDateForLocale(props.createdAt);

  return (
    <Fragment>
      <StyledTableRow>
        {/* Date */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {formattedDate}
          </Typography>
        </TableCell>

        {/* Event Description */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {props.description}
          </Typography>
        </TableCell>

        {/* Type */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {props.type == 'credit_addition' ? 'Grant' : 'Spend'}
          </Typography>
        </TableCell>

        {/* Credits */}
        <TableCell>
          <Typography
            maxWidth="50ch"
            fontSize="inherit"
            fontWeight={props.type == 'credit_addition' ? 'bold' : 'normal'}
          >
            {props.type == 'credit_addition' ? '+' : '-'}{props.amount}
          </Typography>
        </TableCell>

        {/* Balance */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {props.balance}
          </Typography>
        </TableCell>
      </StyledTableRow>
    </Fragment>
  );
};
